import AsyncStorage from '@react-native-async-storage/async-storage';
import { clientConfigPath, DEMO_FLOW_ENABLED } from '../../config/Constant';
import {
  guestBillDetailsFailure,
  guestBillDetailsRequest,
  guestBillDetailsSuccess,
} from '../Reducers/viewBillReducer';
import { setInitAppLogout } from '../Reducers/appConfigReducer';
import FETCH_DETAILS_DEMO_RESPONSE from '../../demo/viewBill/fetchBillDetails.json'

// guestHistory API
export const guestHistory = (reservationNumber,locationId, guestBillIntervalTime) => {
  return async (dispatch, getState) => {
    try {

      const currentGuestDetails = getState().guestDetailsSlice.currentGuestDetails;
      const guestToken = currentGuestDetails?.guestToken;
      // let reservationNumber = await AsyncStorage.getItem('reservationNumber');

      const response = await clientConfigPath.post('/guestHistory/fetch', {
        header: {
          locationId: locationId,
          guestToken: guestToken,
          loggedinGuestToken: guestToken,
          reservationNumber: reservationNumber,
        },
        payload: {},
      });
      console.log('response from guest history', response.data, guestBillIntervalTime);
      if (response.status === 200 || DEMO_FLOW_ENABLED) {
        if(!guestBillIntervalTime || DEMO_FLOW_ENABLED){
          await dispatch(guestBillDetails(reservationNumber,locationId))
        }else{
          const intervalTime = Number(guestBillIntervalTime) * 1000;

          await new Promise(resolve => setTimeout(resolve, intervalTime));

          try {
            await dispatch(fetchBillDetailsWithRetry(reservationNumber, locationId));
            return Promise.resolve({ status: true });
          } catch (error) {
            return Promise.resolve({ status: false, response: error });
          }
        }
        // return Promise.resolve(); // Resolve on success

      } else {

        return Promise.reject('Failed to fetch guest history');
      }

    } catch (error) {

      return Promise.reject('API guestHistory Failed');
    }
  };
};

export const fetchBillDetailsWithRetry = (reservationNumber, locationId, maxRetries = 10) => {
  return async dispatch => {
    let retryCount = 0;
    while (retryCount <= maxRetries) {
      try {
        const response = await dispatch(guestBillDetails(reservationNumber, locationId));
        if(response?.header?.status?.code != "SUCCESS" || (response?.payload && Object.keys(response?.payload)?.length == 0)){
          throw new Error(response?.header?.status?.msg || 'Bill not fetched');
        }
        return Promise.resolve(true);
      } catch (error) {
        retryCount++;
        if (retryCount <= maxRetries) {
          console.log(`Retry attempt ${retryCount}`);
        } else {
          console.log('Maximum retry attempts reached');
          return Promise.reject(error?.message || 'Failed to fetch bill details');
        }
      }
    }
  }
};


// guestBillDetails API
export const guestBillDetails = (reservationNumber,locationId) => {
  return async (dispatch, getState) => {
    dispatch(guestBillDetailsRequest());
    try {
      if(DEMO_FLOW_ENABLED){
        dispatch(guestBillDetailsSuccess(FETCH_DETAILS_DEMO_RESPONSE));
        return Promise.resolve(FETCH_DETAILS_DEMO_RESPONSE);
      }
      const currentGuestDetails = getState().guestDetailsSlice.currentGuestDetails;
      const guestToken = currentGuestDetails?.guestToken;

      // let reservationNumber = await AsyncStorage.getItem('reservationNumber');

      const response = await clientConfigPath.post('guestBillDetails/fetch', {
        header: {
          guestToken: guestToken,
          locationId: locationId,
          reservationNumber: reservationNumber,
        },
        payload: {},
      });
      dispatch(guestBillDetailsSuccess(response.data));
      return Promise.resolve(response.data);
    } catch (error) {
      console.log('error', error);

      dispatch(guestBillDetailsFailure(error.message));

      return Promise.reject('API guestBillDetails Failed');
    }
  };
};




// Send Email API
export const sendGuestMail = (emailId, locationId) => {
  return async (dispatch, getState) => {
    const currentGuestDetails = getState().guestDetailsSlice.currentGuestDetails;
    const guestToken = currentGuestDetails?.guestToken;

    clientConfigPath.post(
      `/guestProfile/updateByLocationAndGuestToken`,
      {
        header: {
          guestToken: guestToken,
          locationId: locationId,
      },
      "payload": {
        "emailId": emailId
      }
      }
    ).then((res) => {
      console.log("sendGuestMail success.", res);
    }).catch((response) => {
        console.log("send Guest Mail Api failed:", response);
    })
  }
}



export const checkOut = (selectedGuest, total, onSuccess, onFailure) => {
  return dispatch => {
      try {
        if(DEMO_FLOW_ENABLED){
          onSuccess("Successfully requested your checkOut.");
          return;
        }
        clientConfigPath.post(
              "/sendCheckOut/send",
              {
                  "header": {
                      "locationId": selectedGuest.location,
                      "guestToken": selectedGuest.guestToken,
                      "loggedinGuestToken": selectedGuest.guestToken,
                      "reservationNumber": selectedGuest.reservationNumber,
                      "balanceAmount": total
                  },
                  "payload": {}
              }
          ).then((res) => {
              console.log("extend stay res", res.data);
              if (res.data.header.status.code === "SUCCESS") {
                  onSuccess("Successfully requested your checkOut.");
              } else if (res.data.header.status.code === "FAILED") {
                  onFailure(res.data.header.status.msg || "");
              }
          })
              .catch((response = {}) => {
                  console.log("extend stay API fail", response.status);
                  if(response.status == 401){
                      dispatch(setInitAppLogout(true));
                  }

                  if(response.response && response.response.data && response.response.data.header && response.response.data.header.status){
                      onFailure(response.response.data.header.status.msg);
                  } else {
                      onFailure("");
                  }
              })
      } catch (e) {
          console.log("error in extend stay API", e);
          onFailure("");
          // if(window.FireBasePlugin){
          //     // window.FirebasePlugin.logMessage("deviceConfig API failed using faceBasedJson() face data = " + faceData + "response = " + response);
          //     window.FirebasePlugin.logError("Checkout Api failed with the status code: " + e)
          //   }
      }
  }
}